<template>
  <!-- 效果图 -->
  <section class="xgt-box">
    <div class="house-title">
      <img
        src="https://images.jianshankeji.com/timepark_select_housetitle.svg"
        alt=""
      />
    </div>
    <pullDown :width="110" :height="150" :title="'户型详情'" :url="require('../../assets/images/pullMsg.png')" top="13%" right="1%"></pullDown>

    <div class="back-icon" @click="backSelect">
      <img src="~@/assets/Back.svg" alt="" srcset="" />
    </div>
    <div class="house-show">
      <el-carousel
        :arrow="nerver"
        :autoplay="false"
        ref="carousel"
        style="height: 100%"
      >
        <el-carousel-item v-for="item in 4" :key="item">
          <img
            class="img-source"
            :src="`https://images.jianshankeji.com/huxing${item}.png`"
            alt=""
          />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- <rightDrawer>
      <div class="right-drawer">
        <img
          class="house-data"
          src="https://images.jianshankeji.com/timepark_house_data.png"
          alt=""
          srcset=""
        />
        <div class="positionContainer">
          <div
            v-for="(item, index) in houseData"
            :key="index"
            :class="['charging-ball', item.name]"
          >
            <div class="wave-wrapper" :style="{ bottom: percent1 + '%' }"></div>
          </div>
          <div
            v-for="(item, d_index) in houseData"
            :key="'d'+d_index"
            :class="['font-style', `${item.name}txt`]"
          >
            {{ item.txt }}
          </div>
        </div>
        <img
          class="house-dataimg"
          src="https://images.jianshankeji.com/timepark_house_dataimg.png"
          alt=""
          srcset=""
        />
      </div>
    </rightDrawer> -->
  </section>
</template>

<script>
export default {
  data() {
    return {
      nerver: "nerver",
      houseData: [
        { name: "hxmj", txt: "53.49m²" },
        { name: "tnmj", txt: "37.33m²" },
        { name: "dcts", txt: "4户" },
      ],
      percent1: 25,
    };
  },

  components: {},

  mounted() {
    this.slideBanner();
  },

  methods: {
    backSelect() {
      wx.miniProgram.redirectTo({
        url: "/pages/select/select", // 小程序中页面的路径
      });
    },
    startAuto() {
      if (this.autoplay == false) {
        this.autoplay = true;
      }
    },
    stopAuto() {
      if (this.autoplay == true) {
        this.autoplay = false;
      }
    },
    slideBanner() {
      //选中item的盒子
      let box = document.querySelector(".el-carousel__container");
      //手指起点X坐标
      let startPoint = 0;
      //手指滑动重点X坐标
      let stopPoint = 0;

      //重置坐标
      let resetPoint = function () {
        startPoint = 0;
        stopPoint = 0;
      };
      let that = this;
      //手指按下
      box.addEventListener("touchstart", function (e) {
        //手指按下的时候停止自动轮播
        that.stopAuto();
        //手指点击位置的X坐标
        startPoint = e.changedTouches[0].pageX;
      });
      //手指滑动
      box.addEventListener("touchmove", function (e) {
        //手指滑动后终点位置X的坐标
        stopPoint = e.changedTouches[0].pageX;
      });
      //当手指抬起的时候，判断图片滚动离左右的距离
      box.addEventListener("touchend", function (e) {
        console.log("1：" + startPoint);
        console.log("2：" + stopPoint);
        if (stopPoint == 0 || startPoint - stopPoint == 0) {
          resetPoint();
          return;
        }
        if (startPoint - stopPoint > 0) {
          resetPoint();
          that.$refs.carousel.next();
          return;
        }
        if (startPoint - stopPoint < 0) {
          resetPoint();
          that.$refs.carousel.prev();
          return;
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
::v-deep .el-carousel__arrow {
  display: none;
}

::v-deep .el-carousel__container {
  position: relative;
  height: 100%;
  // min-height: 415px;
}
::v-deep .el-carousel__indicators--horizontal {
  bottom: 10px;
}
::v-deep .el-carousel__button {
  height: 10px;
  width: 10px;
  border-radius: 50%;
}

.xgt-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  .house-title {
    position: absolute;
    top: 0px;
    left: 59px;
    width: 127px;
    height: 63px;
    z-index: 3;
    image {
      width: 100%;
      height: 100%;
    }
  }
  .back-icon {
    position: absolute;
    top: 10px;
    left: 15px;
    width: 30px;
    height: 30px;
    z-index: 3;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .house-show {
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    .img-source {
      width: 100%;
      height: 100%;
    }
    .swiper-box {
      height: 100%;
    }
  }
}
.right-drawer {
  margin-top: 20px;
  .house-data {
    width: 100%;
    margin-bottom: 8px;
  }
  .house-dataimg {
    width: 100%;
  }
  .positionContainer {
    // width: 40px;
    // border: 1px solid red;
    position: absolute;
    right: 15px;
    top: 0;

    .charging-ball {
      position: absolute;
      top: 16vmin;
      right: 1vmin;
      align-items: center;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background-color: #dbc54f;
      overflow: hidden;
      border: 2px solid #d6c250;
      // outline:#d6c250 ridge  2px ;
      z-index: 100;
      display: flex;
      justify-content: center;
      align-items: center;

      .wave-wrapper {
        position: absolute;
        left: 50%;
        width: 65px;
        height: 80px;
        background-color: rgba($color: #46483f, $alpha: 0.2);
        border-radius: 50%;
        /* 动画完成花费的时间 */
        animation-duration: 5s;
        animation-name: rotate;
        /* 无限次播放动画 */
        animation-iteration-count: infinite;
        /* 动画从头到尾的速度是相同的 */
        animation-timing-function: linear;
      }

      /* 过渡动画 */
      @keyframes rotate {
        0% {
          transform: translate(-50%, 0) rotateZ(0deg);
        }

        50% {
          transform: translate(-50%, -3%) rotateZ(180deg);
        }

        100% {
          transform: translate(-50%, 0) rotateZ(360deg);
        }
      }
    }
    .font-style {
      color: #fff;
      font-size: 12px;
      font-weight: 500;
      width: 60px;
      z-index: 101;
      right: 0;
      text-align: center;
    }
    .hxmj {
      position: absolute;
      top: 5px;
    }
    .hxmjtxt {
      position: absolute;
      top: 25px;
    }
    .tnmj {
      position: absolute;
      top: 80px;
    }
    .tnmjtxt {
      position: absolute;
      top: 100px;
    }
    .dcts {
      position: absolute;
      top: 155px;
    }
    .dctstxt {
      position: absolute;
      top: 175px;
    }
  }
}
</style>